import { arrayOf, func, string } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import { attachmentShape } from '../../prop-types';
import { COLORS } from '../../utils/constants';
import AttachmentsGrid from '../AttachmentsGrid/AttachmentsGrid';

const AttachmentGroupModalContent = ({
  toggle,
  header,
  files,
  onDeleteFileSuccess,
}) => {
  return (
    <>
      <ModalHeader toggle={toggle}>{header}</ModalHeader>
      <ModalBody>
        <AttachmentsGrid
          colCount={6}
          files={files}
          onDeleteFileSuccess={onDeleteFileSuccess}
        />
      </ModalBody>
    </>
  );
};

AttachmentGroupModalContent.propTypes = {
  toggle: func.isRequired,
  header: string.isRequired,
  files: arrayOf(attachmentShape.isRequired).isRequired,
  onDeleteFileSuccess: func.isRequired,
};

const AttachmentGroupModal = createModalToggle(
  'View all',
  AttachmentGroupModalContent,
  {
    color: COLORS.LINK,
  },
  {
    size: 'xl',
    className: 'modal-dialog-scrollable',
  },
);

export default AttachmentGroupModal;
